import { ApiRoutes } from "@/enums/apiRoutes.enum";
import axios from "@/lib/axios";
import {
  Recipe,
  RecipeCreatePayload,
  RecipeSummary,
  RecipeUpdatePayload,
} from "@/types/data";

// Recepti — standalone Recipes API (documentation/features/Recipes.md).
// Proxied + bearer-injected by src/pages/api/recepti/[[...slug]].ts because
// it lives on its own host, separate from the rest of the v1/v2 API.
export const receptiService = {
  async getAll(): Promise<RecipeSummary[]> {
    const response = await axios.get<RecipeSummary[]>(ApiRoutes.RECEPTI);
    return response.data;
  },

  async get(slug: string): Promise<Recipe> {
    const response = await axios.get<Recipe>(`${ApiRoutes.RECEPTI}/${slug}`);
    return response.data;
  },

  async create(payload: RecipeCreatePayload): Promise<Recipe> {
    const response = await axios.post<Recipe>(ApiRoutes.RECEPTI, payload);
    return response.data;
  },

  async update(slug: string, payload: RecipeUpdatePayload): Promise<Recipe> {
    const response = await axios.put<Recipe>(
      `${ApiRoutes.RECEPTI}/${slug}`,
      payload,
    );
    return response.data;
  },

  async remove(slug: string): Promise<{ slug: string; archived: boolean }> {
    const response = await axios.delete<{ slug: string; archived: boolean }>(
      `${ApiRoutes.RECEPTI}/${slug}`,
    );
    return response.data;
  },
};
